// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prac-limit-container {
    background-color: var(--clr-grey-2);
    border: 1px solid var(--clr-grey-10);
    padding: 2rem;
    border-radius: 12px;
    margin-bottom: 2rem;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.03);
  }
  
  .prac-limit-heading {
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--clr-grey-9);
    margin-bottom: 0.5rem;
  }
  
  .prac-limit-description {
    font-size: 1rem;
    color: var(--clr-grey-9);
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }
  
  .prac-limit-loading {
    font-style: italic;
    color: var(--clr-grey-6);
  }
  
  .prac-limit-info {
    font-size: 1rem;
    color: var(--clr-grey-8);
    margin-bottom: 1.2rem;
  }
  
  .prac-limit-value {
    color: var(--clr-primary-6);
    font-weight: bold;
  }
  
  .prac-limit-counter {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 1.2rem;
    justify-content: center;
  }
  
  .counter-value {
    font-size: 1.8rem;
    font-weight: 700;
    min-width: 50px;
    text-align: center;
    /* color: var(--clr-grey-9); */
    padding: 0.4rem 1rem;
    /* border: 1px solid var(--clr-grey-4); */
    border-radius: 8px;
    background-color: white;
  }
  
  .counter-btn {
    background-color: var(--clr-primary-5);
    border: none;
    padding: 0.5rem 1rem;
    font-size: 1.5rem;
    font-weight: bold;
    border-radius: 10px;
    cursor: pointer;
    color: white;
    transition: background 0.3s ease, transform 0.2s ease;
  }
  
  .counter-btn:hover:not(:disabled) {
    background-color: var(--clr-primary-6);
    transform: scale(1.05);
  }
  
  .counter-btn:disabled {
    background-color: var(--clr-grey-6);
    cursor: not-allowed;
    opacity: 0.7;
  }
  
  .prac-limit-save-btn {
    display: block; 
    margin: 1rem auto 0 auto;
    padding: 0.65rem 1.5rem;
    background-color: var(--clr-primary-6);
    color: white;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.3s ease, transform 0.2s ease;
    text-align: center;
  }
  
  .prac-limit-save-btn:hover:not(:disabled) {
    background-color: var(--clr-primary-7);
    transform: translateY(-1px);
  }
  
  .prac-limit-save-btn:disabled {
    background-color: #d3d8de; 
    color: var(--clr-grey-7); 
    cursor: not-allowed;
    opacity: 0.7;
  }
  
  .prac-limit-warning {
    font-size: 0.9rem;
    color: var(--clr-red-light);
    margin-bottom: 1rem;
    text-align: center;
  }
  
  .prac-limit-success {
    background-color: var(--clr-primary-1);
    color: var(--clr-grey-9);
    padding: 0.9rem 1.2rem;
    border-radius: 8px;
    margin-bottom: 1rem;
    font-weight: 500;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }
  
  .prac-limit-initial-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--clr-primary-8);
    padding: 0.6rem 1rem;
    border: 1px solid var(--clr-grey-3);
    border-radius: 8px;
    margin-bottom: 1rem;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
    text-align: left;
    font-size: 0.95rem;
    min-height: 45px;
  }
  
  
  .prac-limit-label {
    font-size: 1.1rem;
    font-weight: 600;
    /* color: var(--clr-grey-8); */
    /* margin-bottom: 0.4rem; */
  }
  
  .prac-limit-badge {
    font-size: 1.3rem;
    font-weight: 700;
    color: var(--clr-primary-6);
    background-color: var(--clr-primary-1);
    padding: 0.4rem 1.2rem;
    border-radius: 8px;
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/ClinicSettings/EditMaxPractitionersLimit.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,qDAAqD;EACvD;;EAEA;IACE,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,uBAAuB;IACvB,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qDAAqD;IACrD,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,oBAAoB;IACpB,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;;EAGA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,sCAAsC;IACtC,sBAAsB;IACtB,kBAAkB;EACpB","sourcesContent":[".prac-limit-container {\n    background-color: var(--clr-grey-2);\n    border: 1px solid var(--clr-grey-10);\n    padding: 2rem;\n    border-radius: 12px;\n    margin-bottom: 2rem;\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.03);\n  }\n  \n  .prac-limit-heading {\n    font-size: 1.6rem;\n    font-weight: 700;\n    color: var(--clr-grey-9);\n    margin-bottom: 0.5rem;\n  }\n  \n  .prac-limit-description {\n    font-size: 1rem;\n    color: var(--clr-grey-9);\n    margin-bottom: 1.5rem;\n    line-height: 1.6;\n  }\n  \n  .prac-limit-loading {\n    font-style: italic;\n    color: var(--clr-grey-6);\n  }\n  \n  .prac-limit-info {\n    font-size: 1rem;\n    color: var(--clr-grey-8);\n    margin-bottom: 1.2rem;\n  }\n  \n  .prac-limit-value {\n    color: var(--clr-primary-6);\n    font-weight: bold;\n  }\n  \n  .prac-limit-counter {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    margin-bottom: 1.2rem;\n    justify-content: center;\n  }\n  \n  .counter-value {\n    font-size: 1.8rem;\n    font-weight: 700;\n    min-width: 50px;\n    text-align: center;\n    /* color: var(--clr-grey-9); */\n    padding: 0.4rem 1rem;\n    /* border: 1px solid var(--clr-grey-4); */\n    border-radius: 8px;\n    background-color: white;\n  }\n  \n  .counter-btn {\n    background-color: var(--clr-primary-5);\n    border: none;\n    padding: 0.5rem 1rem;\n    font-size: 1.5rem;\n    font-weight: bold;\n    border-radius: 10px;\n    cursor: pointer;\n    color: white;\n    transition: background 0.3s ease, transform 0.2s ease;\n  }\n  \n  .counter-btn:hover:not(:disabled) {\n    background-color: var(--clr-primary-6);\n    transform: scale(1.05);\n  }\n  \n  .counter-btn:disabled {\n    background-color: var(--clr-grey-6);\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n  \n  .prac-limit-save-btn {\n    display: block; \n    margin: 1rem auto 0 auto;\n    padding: 0.65rem 1.5rem;\n    background-color: var(--clr-primary-6);\n    color: white;\n    font-size: 1rem;\n    font-weight: 600;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.3s ease, transform 0.2s ease;\n    text-align: center;\n  }\n  \n  .prac-limit-save-btn:hover:not(:disabled) {\n    background-color: var(--clr-primary-7);\n    transform: translateY(-1px);\n  }\n  \n  .prac-limit-save-btn:disabled {\n    background-color: #d3d8de; \n    color: var(--clr-grey-7); \n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n  \n  .prac-limit-warning {\n    font-size: 0.9rem;\n    color: var(--clr-red-light);\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n  \n  .prac-limit-success {\n    background-color: var(--clr-primary-1);\n    color: var(--clr-grey-9);\n    padding: 0.9rem 1.2rem;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    font-weight: 500;\n    text-align: center;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  }\n  \n  .prac-limit-initial-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--clr-primary-8);\n    padding: 0.6rem 1rem;\n    border: 1px solid var(--clr-grey-3);\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);\n    text-align: left;\n    font-size: 0.95rem;\n    min-height: 45px;\n  }\n  \n  \n  .prac-limit-label {\n    font-size: 1.1rem;\n    font-weight: 600;\n    /* color: var(--clr-grey-8); */\n    /* margin-bottom: 0.4rem; */\n  }\n  \n  .prac-limit-badge {\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: var(--clr-primary-6);\n    background-color: var(--clr-primary-1);\n    padding: 0.4rem 1.2rem;\n    border-radius: 8px;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
